/**
 * 水印插件
 * 提供全局水印控制方法
 * 智慧云行（成都）科技有限公司
 * 更新时间：2025-12-16
 */

import WatermarkComponent from './index.vue'

// 水印实例
let watermarkInstance = null

const WatermarkPlugin = {
  /**
   * 安装插件
   */
  install(Vue) {
    // 创建水印组件构造器
    const WatermarkConstructor = Vue.extend(WatermarkComponent)
    
    // 全局水印控制对象
    const watermark = {
      /**
       * 初始化水印
       * @param {Object} options - 配置选项
       */
      init(options = {}) {
        if (watermarkInstance) {
          console.warn('[水印插件] 水印已存在，将先清除旧水印')
          this.clear()
        }
        
        try {
          // 创建水印实例
          watermarkInstance = new WatermarkConstructor({
            propsData: {
              visible: true,
              autoUpdate: true,
              ...options
            }
          })
          
          // 挂载到body
          watermarkInstance.$mount()
          document.body.appendChild(watermarkInstance.$el)
          
          console.log('[水印插件] 水印初始化成功')
          return watermarkInstance
        } catch (error) {
          console.error('[水印插件] 初始化失败:', error)
          return null
        }
      },
      
      /**
       * 显示水印
       */
      show() {
        if (watermarkInstance) {
          watermarkInstance.visible = true
          console.log('[水印插件] 水印已显示')
        } else {
          console.warn('[水印插件] 水印未初始化，请先调用 init()')
        }
      },
      
      /**
       * 隐藏水印
       */
      hide() {
        if (watermarkInstance) {
          watermarkInstance.visible = false
          console.log('[水印插件] 水印已隐藏')
        }
      },
      
      /**
       * 清除水印
       */
      clear() {
        if (watermarkInstance) {
          try {
            // 销毁组件
            watermarkInstance.$destroy()
            
            // 移除DOM元素
            if (watermarkInstance.$el && watermarkInstance.$el.parentNode) {
              watermarkInstance.$el.parentNode.removeChild(watermarkInstance.$el)
            }
            
            watermarkInstance = null
            console.log('[水印插件] 水印已清除')
          } catch (error) {
            console.error('[水印插件] 清除水印时出错:', error)
          }
        }
      },
      
      /**
       * 更新水印
       * @param {Object} options - 新的配置选项
       */
      update(options = {}) {
        if (watermarkInstance) {
          Object.keys(options).forEach(key => {
            if (watermarkInstance.hasOwnProperty(key)) {
              watermarkInstance[key] = options[key]
            }
          })
          watermarkInstance.update()
          console.log('[水印插件] 水印已更新')
        } else {
          console.warn('[水印插件] 水印未初始化，请先调用 init()')
        }
      },
      
      /**
       * 获取水印实例
       */
      getInstance() {
        return watermarkInstance
      },
      
      /**
       * 创建水印（返回组件实例，不自动挂载）
       * @param {Object} options - 配置选项
       */
      create(options = {}) {
        const instance = new WatermarkConstructor({
          propsData: {
            visible: true,
            ...options
          }
        })
        return instance
      }
    }
    
    // 挂载到Vue原型
    Vue.prototype.$watermark = watermark
    
    // 挂载到全局
    if (typeof window !== 'undefined') {
      window.$watermark = watermark
    }
  }
}

export default WatermarkPlugin
